<div class="flex flex-middle flex-wrap"
     [ngClass]="'flex-justify-'+ (component.position || 'center')">
    @for (item of component.items; track item; let isLast = $last; let i = $index) {
    @if (!item.isRegularLink) {
    <href [link]="'event:anchor:' + item.anchorId">
        <button type="button"
                class="p-b-2 p-b-5-s cursor-pointer underline">
            <ng-container *ngTemplateOutlet="title, context:{$implicit: item}"></ng-container>
        </button>
    </href>
    }
    @if (item.isRegularLink) {
    <href [link]="item.url">
        <div class="p-b-2 p-b-5-s cursor-pointer underline"
             [ngClass]="'ta-' + item.text_position || 'center'">
            <ng-container *ngTemplateOutlet="title, context:{$implicit: item}"></ng-container>
        </div>
    </href>
    }
    @if (component.items.length > 1 && !isLast) {
    <span [ngStyle]="{'color': component?.font_color || 'black'}"
          sizeClass="SM: p-l-1 p-r-1, XL: p-l-3 p-r-3"
          class="p-b-2 p-b-5-s">|</span>
    }
    }
</div>

<ng-template #title
             let-item>
    <span class="p-b-2 p-b-5-s underline"
          [ngStyle]="{'color': component?.font_color || 'black'}"
          [innerHtml]="item.title"></span>
</ng-template>
